import { googleLogout } from "@react-oauth/google";
import { ChevronDown, Menu, User, X } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

import { useAuth } from "../../context/Auth/AuthContext";
import useIsLoggedIn from "../../hooks/use-IsLoggedIn";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";

function Header() {
	const storedResumes = localStorage.getItem("resumeList");
	const userLoggedIn = useIsLoggedIn();
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

	const { userData, logout } = useAuth();

	const { firstName } = userData ? userData : { firstName: "" };

	const storeNavigationFlow = () => {
		const updatedNavFlowData = {
			previousPage: "",
			previousSubPage: "",
			previousUrl: "",
		};

		localStorage.setItem(`navFlowData${firstName}`, JSON.stringify(updatedNavFlowData));
	};

	const isDropzOpsUser = localStorage.getItem("isDropzOpsUser");

	return (
		<header className="sticky top-0 z-50 bg-white shadow-xs">
			<nav className="container flex items-center justify-between py-3">
				{/* Logo + Mobile Toggle */}
				<div className="flex items-center gap-3">
					<button
						type="button"
						className="lg:hidden"
						onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
						aria-label="Toggle navigation"
					>
						{mobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
					</button>
					<Link to="/">
						<img className="h-8 w-auto" src="/images/logo.png" alt="Logo" />
					</Link>
				</div>

				{/* Desktop Nav Links */}
				<ul className="hidden items-center gap-6 text-xs uppercase lg:flex">
					{storedResumes && storedResumes.length > 0 ? (
						<li>
							<Link
								className="text-gray-700 hover:text-blue-700"
								onClick={() => {
									storeNavigationFlow();
									window.location.replace("/my-resumes");
								}}
								to="/my-resumes"
							>
								Resumes
							</Link>
						</li>
					) : (
						<>
							<li>
								<Link
									className="text-gray-700 hover:text-blue-700"
									onClick={() => {
										window.location.replace("/resume/select-experience");
									}}
									to="/resume/select-experience"
								>
									Create Resume
								</Link>
							</li>
							<li>
								<Link className="text-gray-700 hover:text-blue-700" to="/employer-landing">
									For Employers
								</Link>
							</li>
						</>
					)}
				</ul>

				{/* Desktop Right Side */}
				<div className="flex items-center gap-4">
					{!userLoggedIn && (
						<ul className="hidden items-center gap-4 text-xs uppercase lg:flex">
							<li>
								<Link
									className="text-gray-700 hover:text-blue-700"
									onClick={() => {
										window.location.replace("/signin");
									}}
									to="/signin"
								>
									Sign In
								</Link>
							</li>
							<li>
								<Link
									className="text-gray-700 hover:text-blue-700"
									onClick={() => {
										window.location.replace("/register");
									}}
									to="/register"
								>
									Register
								</Link>
							</li>
						</ul>
					)}

					{userLoggedIn && (
						<DropdownMenu>
							<DropdownMenuTrigger className="flex items-center gap-1 text-sm font-bold text-gray-900 outline-hidden">
								<User className="h-5 w-5 text-blue-700" />
								{firstName ? `Hi, ${firstName}` : "My Account"}
								<ChevronDown className="h-4 w-4" />
							</DropdownMenuTrigger>
							<DropdownMenuContent align="end" className="w-48">
								<DropdownMenuItem asChild>
									<Link to="/settings">My Settings</Link>
								</DropdownMenuItem>
								{isDropzOpsUser && (
									<>
										<DropdownMenuItem asChild>
											<Link to="/job-market">Control Center</Link>
										</DropdownMenuItem>
										<DropdownMenuItem asChild>
											<Link to="/media-kit">Media Kit</Link>
										</DropdownMenuItem>
									</>
								)}
								<DropdownMenuItem
									onClick={() => {
										logout();
										googleLogout();
									}}
									asChild
								>
									<Link to="/signin">Log Out</Link>
								</DropdownMenuItem>
							</DropdownMenuContent>
						</DropdownMenu>
					)}
				</div>
			</nav>

			{/* Mobile Menu */}
			{mobileMenuOpen && (
				<div className="border-t bg-white px-4 py-3 lg:hidden">
					<ul className="flex flex-col gap-3 text-sm">
						{storedResumes && storedResumes.length > 0 ? (
							<li>
								<Link
									className="text-gray-700 hover:text-blue-700"
									onClick={() => {
										storeNavigationFlow();
										setMobileMenuOpen(false);
									}}
									to="/my-resumes"
								>
									Resumes
								</Link>
							</li>
						) : (
							<>
								<li>
									<Link
										className="text-gray-700 hover:text-blue-700"
										onClick={() => setMobileMenuOpen(false)}
										to="/resume/select-experience"
									>
										Create Resume
									</Link>
								</li>
								<li>
									<Link
										className="text-gray-700 hover:text-blue-700"
										onClick={() => setMobileMenuOpen(false)}
										to="/employer-landing"
									>
										For Employers
									</Link>
								</li>
							</>
						)}
						{!userLoggedIn && (
							<>
								<li>
									<Link
										className="text-gray-700 hover:text-blue-700"
										onClick={() => setMobileMenuOpen(false)}
										to="/signin"
									>
										Sign In
									</Link>
								</li>
								<li>
									<Link
										className="text-gray-700 hover:text-blue-700"
										onClick={() => setMobileMenuOpen(false)}
										to="/register"
									>
										Register
									</Link>
								</li>
							</>
						)}
					</ul>
				</div>
			)}
		</header>
	);
}

export default Header;
